import React from 'react';
import { FieldArray, reduxForm} from "redux-form";
import {useTranslation} from "react-i18next";

import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Box, Typography} from "@material-ui/core";
import SetBusinessHours from "../../../reduxFormComponents/SetBusinessHours";

export const defaultEvents = [
    {
        _id: "1",
        daysOfWeek: [1],
        startTime: '09:00',
        endTime: '17:00',
    },
    {
        _id: "3",
        daysOfWeek: [2],
        startTime: '09:00',
        endTime: '17:00',
    },

    {
        _id: "5",
        daysOfWeek: [3],
        startTime: '09:00',
        endTime: '17:00',
    },
    {
        _id: "7",
        daysOfWeek: [4],
        startTime: '09:00',
        endTime: '17:00',
    },
    {
        _id: "9",
        daysOfWeek: [5],
        startTime: '09:00',
        endTime: '17:00',
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        overflow:'hidden'
    },
    fields: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow:'auto',
    },
    field: {
        marginBottom: theme.spacing(1),
        flexShrink:0,
    },
    actions: {
        display: 'flex',
        justifyContent: 'center',
        flexShrink:0,
    },
    nextButton: {
        width: theme.bigButtonSize,
        marginLeft: theme.spacing(4)
    }

}));

const DefineTimeOff = ({handleSubmit, change, handleBack}) => {
    const classes = useStyles()
    const {t} = useTranslation();

    const resetToDefault = () => change('workingAbility', defaultEvents)

    return <form onSubmit={handleSubmit} className={classes.root}>
        <Box display={'flex'} justifyContent={'center'} flexShrink={0}>
            <Typography variant={"body2"} gutterBottom={true}>{t('business_days_explanation')}</Typography>
        </Box>
        <div className={classes.fields}>
            <Button className={classes.field}
                    color="primary"
                    variant="outlined"
                    onClick={resetToDefault}>{t('reset_to_default')}</Button>
            <FieldArray name="workingAbility" className={classes.field} component={SetBusinessHours} type={'text'}
                   label={t('fullName')}/>
        </div>

        <Box className={classes.actions} pt={1}>
            <Button color="primary" variant="outlined" onClick={handleBack}>
                {t('back')}
            </Button>
            <Button type="submit" color="primary" variant="contained" className={classes.nextButton}>
                {t('next')}
            </Button>
        </Box>
    </form>
}

export default reduxForm({
    form: 'signupSupplierForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(DefineTimeOff);